import { Title } from "@/components/commons/typography/Title"
import { DealSyncSideBarModalBase } from "./DealSyncSideBarModalBase"
import { Modal } from "@/components/modal/Modal"
import { useContext } from "react"
import { BrowserContext } from "context"
import { Text } from "@/components/commons/typography/Text"
import Image from "next/image"
import { useFetchGoogleUrl } from "./hooks/connect-gmail"
import { LOCAL_STORAGE_KEY_GOOGLE } from "./types/deal-sync"

interface DealSyncSideBarModalConnectProps {
  isOpen: boolean
  onClose: () => void
}

export const DealSyncSideBarModalConnect = ({ isOpen, onClose }: DealSyncSideBarModalConnectProps) => {
  const { isMobile } = useContext(BrowserContext)
  const { refetch } = useFetchGoogleUrl()

  const handleClickOnGoogleConnect = async () => {
    try {
      const { data } = await refetch()
      const googleUrl = data?.url
      localStorage.setItem(LOCAL_STORAGE_KEY_GOOGLE, 'connecting')
      window.location.href = googleUrl;
    } catch (error) {
      console.log(error)
      console.log('Error while trying to retrieve the URL for the Google OAuth process and redirecting to the authorization page.')
    }
  }

  return (
    <Modal 
      styles={{
        body: {
          padding: 0,
          background: 'transparent',
        },
        content: {
          background: 'transparent',
          overflow: 'visible',
          minWidth: !isMobile ? '500px' : undefined
        }
      }}
      centered
      size="md"
      opened={isOpen} onClose={onClose} withCloseButton={false}>
      <DealSyncSideBarModalBase>
        <div className="py-4 px-12 bg-primary rounded-18" style={{
          backgroundColor: 'rgba(0, 0, 0, 0.10)'}}>
          <Title 
            variation='xSmall' 
            sizeClass="text-14" 
            lineHeightClass="leading-18" 
            weightClass="font-light" 
            className='text-center'>FIND YOUR TOP PAST BRANDS, COLLABORATORS, AND CREATORS</Title>

        </div>
        <Text className="text-center mt-22">
          Connect your Gmail to uncover collaborators, creators, and key deal-makers from your inbox—your VIP network awaits!
        </Text>

        <div className="flex full-w justify-center mt-22">
          <button
            onClick={handleClickOnGoogleConnect}
            className="bg-white rounded-50 cursor-pointer hover__bg-secondary  flex items-center justify-center gap-8 py-5 px-12 pl-18 border border-solid border-primary border-1">
            <Image
              src="/assets/images/google-icon.svg"
              alt="Google"
              width={32}
              height={32}
            />
            <span className="font-bold text-14">Continue with Google</span>
          </button>

        </div>
      </DealSyncSideBarModalBase>
    </Modal>
  )
}